const Index = () => import(/* webpackChunkName: "historyOrders" */ '@/components/orders/historyOrders')

export default {
    name: 'historyOrders',
    path: 'orderHistory',
    redirect: '/orderHistory/index',
    meta: {label: 'historyOrders'},
    component: {
        render (c) { return c('router-view') }
    },
    children: [
        {
            path: 'index',
            meta: {label: 'Index', auth: true},
            component: Index,
            props: true
        }
    ]
}
